import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { getFactionTextureUrl } from '../../../Common/TextureTools';
import ScoreBars from '../ScoreBars';
import { DefaultEventComponent } from './Default';

class FactionIcon extends Component {
    render() {
        let textureUrl;
        let factionId = this.props.factionId;
        textureUrl = getFactionTextureUrl(factionId);
        return <div id={'scoring-faction-icon'}>
            <img
                src={textureUrl}
                alt="faction"
                style={{ width: '30px' }}
            />
        </div>;
    }
}

export default class RoundScoringReport extends DefaultEventComponent {

    render() {
        let scoreData = this.props.receivedMessage.package.data;
        let gameData = scoreData.game;
        let gamePlayers = scoreData.gameplayer_set;
        gameData.gameplayer_set = gamePlayers;

        return <>
            <Row>Round: {gameData.current_round}</Row>
            {/* <div>{gameData.round_scores}</div> */}
            <Row><ScoreBars {...this.props} gameData={gameData}/></Row>
            <Table style={{color: 'white'}}>
                <thead>
                <tr>
                    <th>Faction</th>
                    {/* <th>Seat</th> */}
                    <th>Player</th>
                    <th>Round Points</th>
                    <th>Current Score</th>
                </tr>
                </thead>
                <tbody>
                {gamePlayers.map((gamePlayer, index) => {
                    return <tr key={index}>
                        <td><FactionIcon factionId={gamePlayer.faction}/></td>
                        {/* <td>{gamePlayer.seat}</td> */}
                        <td>{gamePlayer.name}</td>
                        <td>{gamePlayer.current_round_points}</td>
                        <td>{gamePlayer.current_score}</td>
                        {/* <div>{gamePlayer.randoms_used_this_round}</div> */}
                        {/* <div>{gamePlayer.locked_rooms}</div> */}
                    </tr>;
                })}
                </tbody>
            </Table>


        </>;
    }

}
